import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { PlanOverview } from "@/features/plan/components/plan-overview";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Academy's PLATFORM plan (MONETIZATION_QUOTAS). URL-addressable:
 * `/u/$u/profile/plan`. With monetization OFF it shows `PlanOverview`'s
 * empty state (and the profile link doesn't even appear).
 *
 * Not to be confused with `/u/$u/billing`, which is what a STUDENT owes THEIR
 * academy. See docs/PAYMENT_GATEWAY_KIT.md §"Two billing tiers".
 */
function ProfilePlanPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="2xl">
      <PageHeader title={t(msg`Plan & usage`)} backTo="/profile" />
      <PlanOverview />
    </PageContainer>
  );
}

export const profilePlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/plan",
  component: ProfilePlanPage,
});
